import { useState, useEffect } from 'react';
import { supabase } from '@/integrations/supabase/client';
import { useOrgPermissions } from './useOrgPermissions';

interface SubscriptionLimits {
  canCreate: boolean;
  currentCount: number;
  limitCount: number;
  planName: string;
  expiresAt: string | null;
  loading: boolean;
  error: string | null;
}

export function useSubscriptionLimits() {
  const { userOrgInfo } = useOrgPermissions();
  const [limits, setLimits] = useState<SubscriptionLimits>({
    canCreate: false,
    currentCount: 0,
    limitCount: 0,
    planName: '',
    expiresAt: null,
    loading: true,
    error: null
  });

  const checkLimits = async () => {
    if (!userOrgInfo.orgId) {
      setLimits(prev => ({ ...prev, loading: false, error: 'Organização não encontrada' }));
      return;
    }

    setLimits(prev => ({ ...prev, loading: true, error: null }));

    try {
      const { data, error } = await supabase.rpc('check_contratacao_limits', {
        org_id_param: userOrgInfo.orgId
      });

      if (error) {
        console.error('Erro ao verificar limites:', error);
        setLimits(prev => ({ ...prev, loading: false, error: error.message }));
        return;
      }

      if (data && data.length > 0) {
        const result = data[0];
        setLimits({
          canCreate: result.can_create,
          currentCount: result.current_count,
          limitCount: result.limit_count,
          planName: result.plan_name,
          expiresAt: result.expires_at,
          loading: false,
          error: null
        });
      } else {
        setLimits(prev => ({ ...prev, loading: false, error: 'Nenhum resultado retornado' }));
      }
    } catch (error) {
      console.error('Erro ao verificar limites:', error);
      setLimits(prev => ({ 
        ...prev, 
        loading: false, 
        error: error instanceof Error ? error.message : 'Erro desconhecido' 
      }));
    }
  };

  useEffect(() => {
    if (userOrgInfo.orgId) {
      checkLimits();
    }
  }, [userOrgInfo.orgId]);

  return { 
    ...limits, 
    refetch: checkLimits 
  };
}